<template>
  <pre class="pre" :class="previewClass">{{content}}</pre>
</template>

<script>
import { getFileContent } from "@/api/drive/drive";
export default {
  name: "txtPreview",
  data() {
    return {
      content: ""
    };
  },
  created() {
    // console.log("初始化txtPreview预览组件");
    this.$nextTick(() => {
      this.getFileContent();
    });
  },
  computed: {
    previewData() {
      return this.$store.state.drive.previewData;
    },
    previewClass() {
      return "preview-" + this.previewData.position;
    }
  },
  methods: {
    getFileContent() {
      getFileContent(this.previewData.preview_path)
        .then(res => {
          this.content = res;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        });
    }
  },
  destroyed() {
    // console.log("销毁txtPreview预览组件");
    this.$store.commit("setPreviewData", {
      preview_path: "",
      previewer: "unknowPreview"
    });
  }
};
</script>

<style scoped>
.pre {
  border: none;
  border-radius: 0;
  background-color: #fff;
}
.preview-fullscreen {
  width: 100%;
  height: 100%;
}
.preview-fullscreen-top {
  width: 100%;
  height: 100%;
}
.preview-inside {
  width: 460px;
  height: 280px;
}
</style>